import api from "./helper/client"
import { API_ROUTES } from "./helper/routes"

export const getAllDoctorVisits = async (tenantId: number) => {
    const response = await api.post(`${API_ROUTES.VISIT.DOCTOR}/list/${tenantId}`);
    return response.data.data;
}

export const getAllFirmVisits = async (tenantId: number) => {
    const response = await api.post(`${API_ROUTES.VISIT.FIRM}/list/${tenantId}
        `);
    return response.data.data;
}
